import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Headerbar, Loader, Table, ListContainer, ConfirmButton } from '../../Reusable'

import { Fire, Time, Tools } from '../../../services'
import { CopyToClipboard } from 'react-copy-to-clipboard'

import FadeIn from 'react-fade-in';

const { useHistory } = require('react-router-dom')

interface Props {
  match: any;
}
const TestAccountsScreen: React.FC<Props> = (props) => {
  
  const user = useSelector(state => state.authReducer.user)
  const history = useHistory()
  const [schools, setSchools] = React.useState<any[]>([])

  React.useEffect(() => {

  }, [])

  const fetch = async () => {
    try {
      const schools = await Fire.list(Fire.store().collection('pros'))
      setSchools(schools.filter((item) => item.lat !== undefined))
    } catch (err) {
      console.warn(err)
    }
  }

  const onConnect = async (item: any) => {
    try {
      await Fire.auth().signInWithEmailAndPassword(item.email, item.password)
      history.push('/')
    } catch (err) {
      alert(err.message)
      console.warn(err)
    }
  }

  const data: any[] = [
    {
      id: 'ju',
      type: 'asso',
      name: 'Compte association',
      email: 'coucou2@dev.fr',
      password: 'coucou123',
    },
    {
      id: 'ju2',
      type: 'place',
      name: 'Compte établissement',
      email: 'yo@test.com',
      password: 'coucou123',
    }, 
    {
      id: 'ju3',
      type: 'ads_maker',
      name: 'Compte annonceur',
      email: 'julien1.brunet@epitech.eu',
      password: 'coucou123',
    }, 
  ]

  return (
    <div className="wrapper">
      <Headerbar
        title="Comptes de test"
        />

      <div className="content-wrapper">
        <div className="content users">
          <div className="container-fluid">
            
            <FadeIn>

            <div className="card">
              <div className="card-header">
                <h3 className="card-title">Accounts tests</h3>
              </div>
              <div className="card-body">
                <Table
                  data={data.map((item) => ({
                    ...item,
                    type_col: item.name,
                  }))}
                  columns={[
                    { name: 'Type', string: 'type_col', sortable: true, accessor: 'type_col' },
                    { name: 'Actions', accessor: 'actions', hasButton: true, cell: (item) => (
                      <div>
                        <ConfirmButton
                          title={'Connexion'}
                          confirmTitle={'Êtes-vous sûr de vouloir vous connecter avec ce compte ?'}
                          onPress={(e) => {
                            e.stopPropagation();
                            onConnect(item)
                          }} />
                      </div>
                    )},
                  ]}
                  />
              </div>
            </div>

            </FadeIn>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TestAccountsScreen
